import * as ReactDOM from 'react-dom';
import { instantOffersDisclaimerId } from './utils/constants';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { KmxContainer } from '../KmxContainer';
import theme from '../../theme';
import { ThemeProvider } from '@mui/material/styles';

export default function InstantOffersDisclaimer() {
    const disclaimerEl = document.getElementById(instantOffersDisclaimerId);

    const disclaimer = (
        <ThemeProvider theme={theme}>
            <Box sx={{ mt: 2 }} data-fs-section="HP: Instant Offers Disclaimer">
                <KmxContainer maxWidth="xl">
                    <Box className="disclaimer-section">
                        <Typography variant="caption" color="textSecondary" component="div">
                            <sup>&dagger;</sup> The offer from CarMax is contingent on your providing accurate
                            information. CarMax will conduct a verification of your vehicle and evaluate other vehicle
                            use and history information prior to finalizing the offer. Any differences between the
                            information you provide about your vehicle and the vehicle&apos;s actual condition, use, and
                            history may impact the offer you receive from CarMax.
                        </Typography>
                    </Box>
                </KmxContainer>
            </Box>
        </ThemeProvider>
    );

    return disclaimerEl ? ReactDOM.createPortal(disclaimer, disclaimerEl) : null;
}
